// extracted by mini-css-extract-plugin
export default {"menu_button":"MenuButton_menu_button__UFn4I","menu_icon":"MenuButton_menu_icon__Q5vOI"};